export default __webpack_public_path__ + "static/es-caaab6cfb29bb8c8dd03033600a7e2fd.svg";